import Connector from './connector';
import { StatementOfFactsOverview as Component } from '../StatementOfFactsOverview';

export const TransactionStatementOfFacts = () => <Connector component={Component} />;
